<template>
  <div class="our-content-area ptb-100 bg-gondola3 position-relative z-1">
    <div class="container mw-1356">
      <div class="row align-items-center">
        <div class="col-lg-6 col-xl-7">
          <div class="our-content-img position-relative z-2 text-center text-lg-end">
            <img :src="c.image_url || ourContentImg" alt="our-content" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100" />
            <img src="@/assets/images/shape-5.png" class="shape shape-5 z-1" alt="shape" />
          </div>
        </div>
        <div class="col-lg-6 col-xl-5" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
          <div class="our-content position-relative z-1">
            <span class="top-title">{{ c.top_title }}</span>
            <h2 class="text-white">{{ c.title }}</h2>
            <p class="text-silver">{{ c.description }}</p>
            <p><span class="text-white">{{ c.highlight }}</span></p>
            <ul class="ps-0 list-unstyled content-list">
              <li v-for="(point, i) in c.bullet_points" :key="i" class="d-flex align-items-center">
                <i class="ti ti-circle-check"></i>
                <span>{{ point }}</span>
              </li>
            </ul>
            <RouterLink to="/world-cup-2026" class="btn">
              <span class="border-style">World Cup 2026 Guide</span>
            </RouterLink>
            <img src="@/assets/images/shape-7.png" class="shape shape-7" alt="shape" />
          </div>
        </div>
      </div>
    </div>
    <img src="@/assets/images/shape-6.png" class="shape shape-6" alt="shape" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useContent } from "@/composables/useContent";

export default defineComponent({
  name: "OurContent",
  setup() {
    const { content: c } = useContent("our_content", {
      top_title: "FIFA WORLD CUP 2026",
      title: "Watch All 104 Matches Live in HD & 4K",
      description: "goplayTv delivers every single World Cup 2026 match — from the opening group stage to the Grand Final — in crystal-clear HD and 4K Ultra HD. Hosted across USA, Canada & Mexico, this is the biggest World Cup ever with 48 teams and 104 games. Don't miss a second of it.",
      highlight: "Stream on any device, anywhere in the world — Smart TV, Firestick, Android, iOS, PC.",
      bullet_points: [
        "All 104 World Cup 2026 matches live",
        "HD & 4K Ultra HD picture quality",
        "25,000+ channels from 150+ countries",
        "Anti-freeze & buffer-free technology",
        "500,000+ VOD movies & series on demand",
        "Instant activation — watch in minutes",
      ],
      image_url: "",
    });
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const ourContentImg = require("@/assets/images/our-content.png");
    return { c, ourContentImg };
  },
});
</script>
